/* eslint-disable eqeqeq */

import { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useForm } from "@mantine/form";
import axios from "axios";
import { encode } from "base64-arraybuffer";

import {
  Alert,
  Checkbox,
  Grid,
  Group,
  Modal,
  Radio,
  Space,
} from "@mantine/core";

import { Button } from "@mantine/core";
import { IconAlertCircle } from "@tabler/icons-react";
import { DocumentData, Query, collection, collectionGroup, doc, getDoc, getDocs, getFirestore, limit, query, where, DocumentReference } from "firebase/firestore";

import _ from "underscore";
import { getLatestFilesBinaries } from "../helpers/getLatestFiles";
import { generateRiskRatingPdf } from "../helpers/riskRatingPdf";
import { getAddressDetailsEnglish } from "../helpers/addressHelpers";
import { Approval, BaseResult, Customer, CustomClaims, CustomerPDFData, DocType, EmployeeSignature, NotificationMSG, OrdersPath, PDFDocumentsDataTypes, QRCodeResult, QRCodeRequest, CompletedKYCData, GenerateContractProps, GenerateContractResult, InvoicePaymentConfirmation, Order } from "../types";
import { formatNums } from "../helpers/common";
import { httpsCallable } from "firebase/functions";
import { useFunctions } from "../helpers/firebaseContext";
import { getStorage, ref } from "firebase/storage";
import { getDownloadURL } from "firebase/storage";
import { ConfigContext, MyUserDataContext } from "../contexts";
import { useSessionStorage } from "@mantine/hooks";

declare const createPDF: (data: string) => Promise<{
  data: string,
  status: string
}>;
export interface GeneratePDFModalProps {
  rows: any[];
  opened: boolean;
  fromServer?: boolean;
  setOpened: (value: boolean) => void;
  generatingForCollection: string, // what am i generating a pdf for (order/service/kyc(customer)/ipo)
  documentsToFetch?: PDFDocumentsDataTypes[];
  dataCollectionName?: string;
  dataAccess?: string;
  getCustomerDataKey?: string;  //this is the customer object embedded in the order or service
  // generatedType?: string;
  metaTypes?: DocType[];
  objID?: string;
  includeKYC?: boolean;
  customPath?: string,
  customFileName?: string,
  setPending?: (value: boolean) => void;
  onGenerateComplete?: () => void
  manual?: boolean;
  withFilledKYC?: boolean;
  kycID?: string;
  hidePDFOptions?: boolean,
  manualEmptyFiles?: OrdersPath[];
  ///For the AML PDF
  aml_screening?: Record<string, any>;
  paymentConfirmations?: InvoicePaymentConfirmation[];
  completedKYCData?: CompletedKYCData;
  transactionContractRef?: DocumentReference;
  pdfTags?: string[],

  // This is Use only for the redemption
  orderRedemptionRef?: DocumentReference,
  // documentActions?: Record<string, Array<Record<string, any>>>
  /* documentActions is in rows.  is basically something like this:  It shows who took an action on which document (really just kyc and order for now.)

  {
    "kyc": [
      {
        "date": {
          "seconds": 1711357400,
          "nanoseconds": 60000000
        },
        "level": "normal",
        "name": "Abdullah AlAttal",
        "id": "zhcHWIwp5SZlmw9Tjp89Zcc3JbT2",
        "type": "review",
        "info": {
          "identities": {
            "microsoft.com": [
              "c7627aa9-28d9-4f6d-bd45-015ab2a38221"
            ],
            "email": [
              "aalattal@kfhcapital.com.kw"
            ]
          },
          "sign_in_provider": "microsoft.com"
        }
      }

    ],
    "order": [
      {
        "date": {
          "seconds": 1710757929,
          "nanoseconds": 698000000
        },
        "level": "normal",
        "name": "Abdullah AlAttal",
        "id": "zhcHWIwp5SZlmw9Tjp89Zcc3JbT2",
        "type": "review",
        "info": {
          "identities": {
            "microsoft.com": [
              "c7627aa9-28d9-4f6d-bd45-015ab2a38221"
            ],
            "email": [
              "aalattal@kfhcapital.com.kw"
            ]
          },
          "sign_in_provider": "microsoft.com"
        }
      },
      {
        "date": {
          "seconds": 1710758623,
          "nanoseconds": 313000000
        },
        "level": "normal",
        "name": "Hamad AlAjmi",
        "id": "yw8PGSnbtHdGN9bBmy68VgviXxE2",
        "type": "approve",
        "info": {
          "identities": {
            "microsoft.com": [
              "287c39bf-8016-4cf4-ae25-eb69505ad732"
            ],
            "email": [
              "halajmi@kfhcapital.com.kw"
            ]
          },
          "sign_in_provider": "microsoft.com"
        }
      }
    ]
  }


  */
}

const GeneratePDFModal = (props: GeneratePDFModalProps) => {
  const rows = props.rows;
  const opened: boolean = props.opened;
  const completedKYCData = props.completedKYCData;
  const [selectedContractPdfTags, setSelectedContractPdfTags] = useState<string[]>([]);
  const setOpened = props.setOpened;
  const documentsToFetch: PDFDocumentsDataTypes[] = props.documentsToFetch || []
  const dataCollectionName = props.dataCollectionName;
  const dataAccess = props.dataAccess;
  const getCustomerDataKey = props.getCustomerDataKey
  // const generatedType = props.generatedType
  const metaTypes = props?.metaTypes;
  const [confirming, setConfirming] = useState<boolean>(false);
  const [showQRCodePDF, setShowQRCodePDF] = useState<boolean>(true);
  const [showGenerateContract, setShowGenerateContract] = useState<boolean>(true);
  const [docsDone, setDocsDone] = useState<number>(0)
  const [defaultCheckedDocuments, setDefaultCheckedDocuments] = useSessionStorage<PDFDocumentsDataTypes[]>({
    key: 'pdf_generate_default_' + props.generatingForCollection,
    getInitialValueInEffect: false,
  });

  const [documentsToInclude, setDocumentsToInclude] = useState<PDFDocumentsDataTypes[]>(defaultCheckedDocuments ?? []);
  const [contractLang, setContractLang] = useState<'ar' | 'en'>('ar');
  useEffect(() => {
    if (documentsToInclude)
      setDefaultCheckedDocuments(documentsToInclude)
  }, [documentsToInclude])

  const getDocumentKey = (doc?: PDFDocumentsDataTypes) => {
    if (!doc) return "";
    if (doc.metaKey) return `meta:${doc.metaKey}`;
    if (doc.path) return `path:${doc.path}`;
    return "";
  };

  const getAllowedDocumentKeys = () => {
    const allowed: PDFDocumentsDataTypes[] = [];
    const pdfDocs = config?.pdf_documents;

    if (!props.completedKYCData) {
      if (pdfDocs?.kyc) {
        allowed.push({ name: "kyc", path: pdfDocs.kyc, title: "KYC Document" });
      }
      allowed.push({ path: "https://storage.googleapis.com/public-pdfs/fatca-cayman.pdf", title: "FATCA Document" });
      allowed.push({ path: "https://storage.googleapis.com/public-pdfs/highrisk_letter.pdf", title: "High Risk Document" });
    }

    if (metaTypes?.length) {
      metaTypes.forEach((metaType) => {
        if (metaType.key === "hasExpiryDate") return;
        if (metaType.key) {
          allowed.push({ metaKey: metaType.key, title: metaType.name });
        }
      });
    }

    allowed.push({ path: "Civil ID", title: "Civil ID" });
    allowed.push({ path: "Risk Status", title: "Risk Status" });

    if (props.aml_screening && Object.keys(props.aml_screening).length > 0) {
      allowed.push({ path: "AML Screening Data", title: "AML Screening Data" });
    }

    if (props.paymentConfirmations) {
      allowed.push({ path: "Payment Confirmation", title: "Payment Confirmation" });
    }
    if (props.generatingForCollection === "transaction") {
      allowed.push({ path: "Payment Details", title: "Payment Details" });
    }

    return new Set(allowed.map(getDocumentKey).filter(Boolean));
  };

  //handle that if the previous selected checkboxes are not visible anymore we need to remove them from the selected list
  useEffect(() => {
    if (opened) {
      let defaultDocs = [...(defaultCheckedDocuments ?? [])];
      defaultDocs = defaultDocs.filter((doc) => doc?.title !== "Civil ID Document");
      const allowedDocKeys = getAllowedDocumentKeys();
      if (allowedDocKeys.size > 0) {
        defaultDocs = defaultDocs.filter((doc) => allowedDocKeys.has(getDocumentKey(doc)));
      }
      if (!props.paymentConfirmations) {
        defaultDocs = defaultDocs.filter(doc => doc.path !== "Payment Confirmation")
      }
      if (!(props.aml_screening && Object.keys(props.aml_screening).length > 0)) {
        defaultDocs = defaultDocs.filter(doc => doc.path !== "AML Screening Data")
      }

      if (!(props.completedKYCData || props.transactionContractRef)) {
        defaultDocs = defaultDocs.filter(doc => doc.path !== "Generate Contract")
        setShowGenerateContract(false);
        setSelectedContractPdfTags([]);
      }

      if (props.orderRedemptionRef || props.transactionContractRef) {
        setShowGenerateContract(true);
        setSelectedContractPdfTags([]);
      }

      if (props.manual) {
        setShowQRCodePDF(false);
      }
      setDocumentsToInclude(defaultDocs);
    }
  }, [opened]);

  const [msg, setMsg] = useState<NotificationMSG | null>(null);
  const [generatedDocument, setGeneratedDocument] = useState<string>();
  const config = useContext(ConfigContext);

  const functions = useFunctions();
  const getEncryptQRCode = httpsCallable<QRCodeRequest, QRCodeResult>(functions, "getEncryptQRCode");
  const generateContractPDF = httpsCallable<GenerateContractProps, GenerateContractResult>(functions, "generateContractPDF");
  const userData = useContext(MyUserDataContext);
  const isHR = (userData?.firebaseTokenResult?.claims?.customClaims as CustomClaims | undefined)?.hr === true;
  const location = useLocation();

  // An employee's KYC is HR only: for anyone else the KYC parts are left out of the PDF
  // and the rest (order/service/transaction forms and their files) is still generated.
  const isKycDocument = (d?: PDFDocumentsDataTypes) =>
    d?.name === "kyc" ||
    (d?.path != null && [config?.pdf_documents?.kyc, config?.pdf_documents?.company_kyc, "Civil ID", "Risk Status",
      "https://storage.googleapis.com/public-pdfs/fatca-cayman.pdf",
      "https://storage.googleapis.com/public-pdfs/highrisk_letter.pdf"].includes(d.path)) ||
    !!d?.path?.includes("kycind");
  const setCamelCaseKey = (base: string, prefix?: string) => {
    if (prefix) {
      return prefix + base.charAt(0).toUpperCase() + base.slice(1);
    }
    return base.charAt(0).toLowerCase() + base.slice(1);
  };

  const embedApprovalsInDocumentData = (PDFDataDocuments: Record<string, any>, approvals: Approval[], employeeSignaturesObject: Record<string, EmployeeSignature>, prefix?: string,) => {

    const embedDataForAction = (actionName: string, approval: Approval) => {
      PDFDataDocuments[setCamelCaseKey(actionName, prefix)] = approval.name;
      PDFDataDocuments[setCamelCaseKey(actionName + "Date", prefix)] = approval.date.toDate().toLocaleDateString('en-GB');
      PDFDataDocuments[setCamelCaseKey(actionName + "Signature", prefix)] = employeeSignaturesObject[approval.info?.identities?.email?.[0]]?.signature;
      PDFDataDocuments[setCamelCaseKey(actionName + "Title", prefix)] = approval.title;
      PDFDataDocuments[setCamelCaseKey(actionName + "Email", prefix)] = approval.info?.identities?.email?.[0];
    };
    approvals?.forEach((approval) => {
      if (approval.type === "review") {
        embedDataForAction("reviewed", approval);
      } else if (approval.type === "approve") {
        if (approval.level === "normal") {
          embedDataForAction("approved", approval);
        } else if (approval.level === "executive") {
          embedDataForAction("execApproved", approval);
        }
      }
      else if (approval.type === "authorized_signatory_approve") {
        embedDataForAction("authorizedSignatoryApproved", approval);
      }
    });

  }

  const fetchPdfAsArrayBuffer = async (url: string): Promise<ArrayBuffer> => {
    try {
      const response = await axios.get(url, {
        responseType: 'arraybuffer',
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching the PDF:', error);
      throw new Error('Failed to fetch PDF file.');
    }
  };


  async function generateQRCodesForCustomers(customersList: Customer[]): Promise<Customer[]> {
    if (!userData) {
      throw new Error("User authentication required. No user data found. Please log in and try again.");
    }
    if (!customersList?.length) {
      return customersList;
    }

    try {
      const token = await userData.getAzureADToken?.(userData);
      if (!token) {
        throw new Error("Unable to retrieve your Microsoft authentication token. Please refresh the page or sign in again to continue.");
      }

      const urlPathName = location.pathname;
      const baseUrl = window?.location?.origin;
      /// Valid Customers with paciData, If no paciData it's removed
      const validCustomers = customersList.filter(user => user.id && user.paciData);

      if (!validCustomers.length) {
        return customersList;
      }

      const customersQRList = new Map<string, string>();

      // Build the path for each [customers,orders,services,transactions]
      // Example With kycID: /customers/123/kyc/456
      // Example Without: /customers/123
      const buildPath = (customer: any, basePath: string) =>
        customer.kycID ? `${basePath}/kyc/${customer.kycID}` : basePath;

      if (urlPathName.startsWith("/customers")) {
        validCustomers.forEach(customer => {
          customersQRList.set(customer.id!, buildPath(customer, `/customers/${customer.id}`));
        });
      } else {
        const firstCustomer = validCustomers[0];
        customersQRList.set(firstCustomer.id!, buildPath(firstCustomer, urlPathName));
      }

      if (!customersQRList.size) {
        return customersList;
      }

      // Function call 
      const qrCodeResult = await getEncryptQRCode({
        baseUrl,
        customersQRList: Object.fromEntries(customersQRList),
        token
      });

      const resCustomersQRList = qrCodeResult.data?.customersQRList;
      if (resCustomersQRList) {
        const customerMap = new Map(customersList.map(c => [c.id, c]));

        /// Add QR code URLs on customers
        Object.entries(resCustomersQRList).forEach(([customerId, qrCodeUrl]) => {
          //console.log(`Customer ID: ${customerId}, QR Code URL: ${qrCodeUrl}`);
          const customer = customerMap.get(customerId);
          if (customer) customer.qrCodeUrl = qrCodeUrl;
        });
      }

      return customersList;

    } catch (error) {
      console.error("Failed to generate QR codes:", error);
      return customersList;
    }
  }

  async function generateContractCall(): Promise<string | null> {
    try {
      console.log('🔵 Starting generateContractCall...', rows);

      let productRef = '';
      // Check if props has orderRedemptionRef, then call generateContractPDF using that orderRedemption Order Form.
      if (props.transactionContractRef) {
        productRef = props.transactionContractRef.path;
      } else if (!props.orderRedemptionRef) {
        if (!completedKYCData?.kyc_id || !completedKYCData?.customerId || !completedKYCData?.productRef) {
          return null;
        }

        // Check if productRef only has the customer path (e.g., "customers/10000012")
        const pathSegments = completedKYCData?.productRef.split('/');
        const needsKycPath = pathSegments.length === 2 && pathSegments[0] === 'customers'; // Only "customers/{id}"

        productRef = needsKycPath
          ? `${completedKYCData.productRef}/kyc/${completedKYCData.kyc_id}`
          : completedKYCData.productRef;
      }
      const baseUrl = window?.location?.origin;

      // orderRedemption only one page [order-form]
      if (props.orderRedemptionRef) {
        productRef = props.orderRedemptionRef.path;
        selectedContractPdfTags.splice(0, selectedContractPdfTags.length, "order-form");
      }

      if (productRef === '') {
        console.log('🔴 productRef is Empty');
        return null;
      }

      const result = await generateContractPDF({
        productRef: productRef,
        pdfTags: selectedContractPdfTags,
        baseUrl: baseUrl,
        showQRCodePDF: showQRCodePDF,
        lang: contractLang,
        empty: props.manual && !props.withFilledKYC,
      });

      console.log('🟢 Result received:');
      if (result.data.success !== true) {
        console.log('🔴 Result was not successful.');
        return null;
      }
      return result.data.pdfBase64;

    } catch (error) {
      console.error('🔴 Error in generateContractCall:', error);

      return null;
    }
  }


  const handleSubmitGeneratePDF = async () => {
    const db = getFirestore();
    const includePaymentDetails = props.generatingForCollection === "transaction"
      && documentsToInclude.some(document => document.path === "Payment Details");

    const mainPDFDataDocuments: Record<string, any>[] = [];
    const hideKycRows: boolean[] = [];


    //let's get the firestore documents needed to fill out the PDF
    for (let idx in rows) {
      let row = rows[idx];

      let PDFDataDocuments: Record<string, any> = {};




      //these are the employee signatures stored in the signatures collection to stamp on PDFs (as if they're real)
      let employeeSignatures = (await getDocs(collection(db, `signatures`))).docs.map((doc) => { return { ...doc.data(), email: doc.id } as EmployeeSignature });

      const employeeSignaturesObject: Record<string, EmployeeSignature> = {};
      //to easily look up by email, let me just make an object instead of searching an array.
      employeeSignatures.forEach(data => {
        employeeSignaturesObject[data.email] = data;
      });


      console.log("employee signatures", employeeSignaturesObject);
      // }
      // else {
      //   customerData = row[getCustomerDataKey];
      //   console.log("We already have the customer obj which should hopefully contain latest KYC", customerData.lastValidKYC?.kycID);
      // }

      //does that order have a valid KYC attached to it?

      //we're gonna need the customer's KYC for everything pretty much, so let's just get that regardless of what docs are chosen.

      let kycRef;
      const customerID = getCustomerDataKey ? row[getCustomerDataKey]?.id : row?.id;
      const customerData: Customer = (await getDoc(doc(db, `customers/${customerID}`))).data() as Customer;
      const hideKyc = customerData?.employee === true && !isHR;
      if (hideKyc && props.generatingForCollection === "customer") {
        throw new Error(`Only HR can generate the KYC of an employee (${customerData.name_en ?? customerID}).`);
      }
      hideKycRows.push(hideKyc);

      if (row.kyc_id) {
        console.log("Ok attached KYC ID is ", row.kyc_id);
        kycRef = doc(db, `customers/${customerID}/kyc/${row.kyc_id}`);
      }
      else {
        //get the latest KYC since there's no KYC attached.

        //does he have a valid KYC?  Let's get that.
        if (customerData?.lastValidKYC?.kycID) {
          console.log("Ok latest KYC ID is ", customerData?.lastValidKYC?.kycID);
          kycRef = doc(db, `customers/${customerID}/kyc/${customerData?.lastValidKYC?.kycID!}`);
        }

      }
      //handle that manual kyc dont need to be valid in order to generate pdf
      if (props.manual && props.kycID) {
        console.log("manual KYC ID is ", props.kycID);
        kycRef = doc(db, `customers/${customerID}/kyc/${props.kycID}`);
      }
      if (kycRef) {

        const latestKYCDocQuery = await getDoc(kycRef);

        if (latestKYCDocQuery.exists()) {
          PDFDataDocuments = { ...PDFDataDocuments, ...latestKYCDocQuery.data(), id: customerID, kycID: latestKYCDocQuery.id };

          //get the kyc approvals!

          console.log("Got it!", PDFDataDocuments);

          //Ok so now we need to get the approvals for that KYC!  Let's get that.
          const kycActionsRef = doc(collection(kycRef, "private"), "actions");
          const kycActionsDoc = await getDoc(kycActionsRef);
          if (kycActionsDoc.exists()) {
            const approvals = (kycActionsDoc.data().approvals ?? []) as Approval[];

            embedApprovalsInDocumentData(PDFDataDocuments, approvals, employeeSignaturesObject, "kyc",);

          }




          //do a fancy sentence for the KYC source of income and source of wealth
          // if (PDFDataDocuments.sourcesOfIncome) {
          //   PDFDataDocuments.sourcesOfIncomeSentence = PDFDataDocuments.sourcesOfIncome.map((income: string) => {
          //     return PDFDataDocuments.sourcesOfIncomeTransformers[income];
          //   }).join(", ");
          // }

        }

      }
      else {
        console.warn("There is no latest KYC ID for", customerID);
      }
      console.log("documentsToInclude IS HERE ------>>>", documentsToInclude);


      for (const documentObj of documentsToFetch) {
        if (documentObj.name) {

          console.log("COLLECTION NAME IS HERE ------>>>", documentObj);

          let dataCollectionQuery: Query<DocumentData>;
          if (documentObj.type === "collectionGroup") {
            dataCollectionQuery = query(collectionGroup(db, documentObj.name), where(documentObj.subCollectionAccessorName!, '==', row[documentObj.subCollectionAccessorName!]), limit(1));
          }
          else if (documentObj.type === "collection" && dataCollectionName && dataAccess) {
            const dataCollection = collection(db, dataCollectionName, row[dataAccess] as string);
            dataCollectionQuery = query(dataCollection, limit(1))
          }
          else {
            continue;  //nothing to query
          }


          // promises[idx].push(
          let snapshot = await getDocs(dataCollectionQuery);
          if (snapshot.docs.length > 0) {
            PDFDataDocuments = { ...PDFDataDocuments, ...snapshot.docs[0].data() };
            // Keep the complete transaction separate from KYC data and display formatting.
            if (includePaymentDetails && documentObj.name === "transactions") {
              PDFDataDocuments.paymentDetailsTransaction = snapshot.docs[0].data();
            }
          }
          // )
        }
      }

      if (includePaymentDetails && !PDFDataDocuments.paymentDetailsTransaction) {
        throw new Error("Unable to load the transaction for Payment Details. Please refresh and try again.");
      }

      const documentActions = row.documentActions;

      console.log("Document actions!!!!", documentActions);

      embedApprovalsInDocumentData(PDFDataDocuments, documentActions, employeeSignaturesObject);

      mainPDFDataDocuments.push(PDFDataDocuments);
    }

    // handle risk states by removing the "Override:" prefix if it exists because it causes problems in the PDF generation
    mainPDFDataDocuments.forEach(document => {
      const risk = document?.state?.risk;

      if (typeof risk === 'string' && risk.startsWith('Override:')) {
        document.state.risk = risk.replace('Override:', '').trim();
      }
    });


    console.log("Main PDF Data documents", mainPDFDataDocuments);


    let customersList = mainPDFDataDocuments.map((customerDataObj, idx) => {

      let mainPDFData: any = {
        "is_individual": true,
        "wire_transfer": true,
      };



      mainPDFData = { ...mainPDFData, ...customerDataObj }

      // Add Payment Confirmation Data with static fallback
      mainPDFData.paymentConfirmations = props.paymentConfirmations;


      let fieldsToConvertToDateStrings = ["birthDate", "civilIDExpiryDate", "passportExpiryDate", "created", "date", "transferDate"]
      let numbersToFormatFields: string[] = ["transferAmount", "fees", "postNavAmount", "units"]

      numbersToFormatFields?.forEach((field: string) => {
        if (mainPDFData[field] != null) {
          mainPDFData[field] = formatNums(mainPDFData[field], ",")
        }
      })
      for (const field of fieldsToConvertToDateStrings) {
        if (mainPDFData[field] != null) {
          mainPDFData[field] = (new Date(mainPDFData[field].toDate())).toLocaleDateString('en-GB');
        }
      }

      if (mainPDFData["address"] != null && Object.entries(mainPDFData["address"])) {
        mainPDFData["address"]["DetailsEnglish"] = getAddressDetailsEnglish(mainPDFData["address"])
      }

      if (mainPDFData.name_en) {
        mainPDFData["nameEnSplit"] = { ...mainPDFData.name_en.split(" ") }
      }
      if (mainPDFData.name_ar) {
        mainPDFData["nameArSplit"] = { ...mainPDFData.name_ar.split(" ") }
      }
      if (mainPDFData.civilID) {
        mainPDFData["civilIDSplit"] = { ...mainPDFData.civilID.split("") }
        mainPDFData["countryOfResidence"] = "KW"
      }
      if (mainPDFData.birthDate) {
        mainPDFData["birthDateSplit"] = { ...mainPDFData.birthDate.split("/") }
      }
      if (mainPDFData.civilIDExpiryDate) {
        mainPDFData["civilIDExpiryDateSplit"] = { ...mainPDFData.civilIDExpiryDate.split("/") }
      }

      if (mainPDFData.passportExpiryDate) {
        mainPDFData["passportExpiryDateSplit"] = mainPDFData.passportExpiryDate.split("/")
      }

      if (mainPDFData.created) {
        mainPDFData["createdSplit"] = { ...mainPDFData.created.split("/") }
      }
      if (mainPDFData?.transactionTimestamp) {
        mainPDFData["created"] = (mainPDFData?.transactionTimestamp?.toDate())?.toLocaleDateString("en-GB");
      }
      if (mainPDFData?.customerObj?.address_from_finder) {
        mainPDFData["address_from_finder"] = mainPDFData?.customerObj?.address_from_finder;
      }

      if (mainPDFData.gender === "F") {
        mainPDFData["female"] = true

      }
      else {
        mainPDFData["male"] = true
      }





      let documentsToAdd = [...documentsToInclude]

      console.log("documentsToFetch", documentsToFetch);

      if (documentsToFetch?.length) {

        documentsToFetch.forEach((documentToFetch) => {

          if (documentToFetch?.documentsToAddFunction) {
            console.log("documentsToAddFunction ----- mainPDFData", mainPDFData);

            let addedFiles = documentToFetch?.documentsToAddFunction(mainPDFData!)
            if (import.meta.env.MODE === 'development') {
              console.log("already addedFiles ----->", addedFiles);
            }

            //Check if kyc is already included in the documents or not as if it not included we need to add it in case of manual and the kyc need to be filled
            if ((addedFiles?.some((doc: any) => doc.path && (doc.path as string).includes('kycind')) || !addedFiles?.length) != true && props.manual && props.withFilledKYC) {
              setDocumentsToInclude([...documentsToInclude, { name: "kyc", path: customerDataObj.commercial_register ? config.pdf_documents!.company_kyc : config.pdf_documents!.kyc, title: "KYC Document", }]);
              documentsToAdd = [...documentsToInclude, completedKYCData ? {
                name: "kyc",
                path: customerDataObj.commercial_register ? config.pdf_documents!.company_kyc : config.pdf_documents!.kyc
                , title: "KYC Document",
              } : {}];
            }
            console?.log("THE ADDED FILES ARE ====>", addedFiles);

            console.log("documentsToAdd ----->", documentsToAdd);


            //filter out based on agreementType if voting, nonvoting
            let voting = false;
            if (mainPDFData.voting == true) {
              voting = true
            }
            // console.log("voting is", voting);

            addedFiles = addedFiles?.filter((orderPath) => {
              //does the agreementType field exist?
              // console.log("Agreement type is ", orderPath.agreementType);
              if (orderPath.agreementType) {
                const include = voting ? orderPath.agreementType === "voting" : orderPath.agreementType === "nonvoting";
                // console.log("included", include);
                return include;
              }
              return true;
            })

            console.log("addedFiles", addedFiles);

            if (addedFiles?.length) { documentsToAdd = [...documentsToAdd, ...addedFiles] }
          }

        })
      }

      if (hideKycRows[idx]) documentsToAdd = documentsToAdd.filter((d) => !isKycDocument(d));
      console.log("documentsToAdd", documentsToAdd);

      let idNumber = mainPDFData?.iban
      mainPDFData = {
        ...mainPDFData,
        // "Risk Status" is generated client-side into userFiles below; the pdf
        // script would treat its sentinel path as a URL to fetch, so keep it out.
        documentsToInclude: documentsToAdd.filter((docToAdd) => docToAdd?.path != null && docToAdd.path !== "Risk Status"),
        idNumber: idNumber,
      }
      //workaround for a quick fix, needs to be updated to recursive function to allow nested values in pdf script 
      if (mainPDFData?.paciData) {
        mainPDFData = {
          ...mainPDFData,
          paciInfo: mainPDFData?.paciData.PersonalData,
          paciAddress: mainPDFData?.paciData.PersonalData?.Address,
          paciGovData: mainPDFData?.paciData.PersonalData?.GovData,
        }
      }



      //if it's a kuwaiti national, add the TIN.  
      //TODO: I think it's a better idea to populate this automatically during KYC process

      if (mainPDFData.nationality === "KW" && (mainPDFData.tin == null || mainPDFData.tin.length === 0)) {
        mainPDFData.tin = [{
          available: true,
          country: "KW",
          number: mainPDFData.civilID,
          type: "Civil ID"
        }]
      }


      return mainPDFData;
    });

    console.log("MAIN PDF DATA!", customersList);

    //Are there any files we need to add to the PDF?
    // if (documentsToInclude?.some((doc: any) => doc?.metaKey?.length > 0))
    {
      const customersListFiles: Promise<CustomerPDFData>[] = customersList.map(async (obj: any, idx: number) => {


        let pathKyc = ""
        let uploadPath = ``;
        if (props.customPath) {
          if (getCustomerDataKey) {
            pathKyc = `kyc/${obj[getCustomerDataKey]?.id}/`
          } else {
            uploadPath = `${props.customPath}/kyc/${obj.id}`;
          }
          uploadPath = props.customPath;
        } else {
          if (getCustomerDataKey) {
            pathKyc = `kyc/${obj[getCustomerDataKey]?.id}/`
            uploadPath = `orders/${obj.id}`;
          }
          else {
            pathKyc = `kyc/${obj.id}/`
            uploadPath = `kyc/${obj.id}`;

          }
        }
        let pathOrders = `orders/${obj.id}/`
        if (hideKycRows[idx]) pathKyc = "";


        //handle the empty forms and check if kyc need to be added or not
        let userFiles: any[] = [];
        if (props.manual && !props.withFilledKYC) {
          let isKYCAdded = false;
          // Removed unnecessary debugging log.

          if (props.manualEmptyFiles) {
            // Removed unnecessary debugging log.
            for (let index = 0; index < props.manualEmptyFiles.length; index++) {
              const fileData = props.manualEmptyFiles[index];
              if (fileData.path.includes("kycind-update-closed-ended")) {
                isKYCAdded = true;
              }
              const file = await fetchPdfAsArrayBuffer(fileData.path);
              userFiles.push({
                file: encode(file), type: 'pdf', fileMetas: []
              });
            }
            console.log("isKYCAdded =======>>>>", isKYCAdded);

          }

          if (!isKYCAdded && !hideKycRows[idx]) {
            console.log("is OBJ the custiomer ??? where is the customer =======>>>>", obj);
            let theKycFilePath = ((getCustomerDataKey && obj[getCustomerDataKey].commercial_register) || obj?.commercial_register) ? config.pdf_documents!.company_kyc : config.pdf_documents!.kyc
            console.log("THE KYC PATH IS ======>", theKycFilePath)

            const file = await fetchPdfAsArrayBuffer(theKycFilePath);
            userFiles.push({
              file: encode(file), type: 'pdf', fileMetas: []
            });
          }
        } else {
          userFiles = await getLatestFilesBinaries(pathKyc, pathOrders, hideKycRows[idx] ? documentsToInclude.filter((d) => !isKycDocument(d)) : documentsToInclude, props.kycID)
        }


        // "Risk Status" appends the same risk rating card the KYC risk card's
        // "Risk PDF" button generates (client-side, pdf-lib).
        if (!hideKycRows[idx] && documentsToInclude?.some((docObj: any) => docObj.path === "Risk Status")) {
          const riskCustomer = (getCustomerDataKey ? rows[idx]?.[getCustomerDataKey] : rows[idx]) ?? obj;
          const riskPdfBytes = await generateRiskRatingPdf({
            customer: riskCustomer,
            kyc: obj,
            riskCode: obj?.state?.risk_code,
            riskLabel: obj?.state?.risk,
          });
          const riskPdfBuffer = new ArrayBuffer(riskPdfBytes.byteLength);
          new Uint8Array(riskPdfBuffer).set(riskPdfBytes);
          userFiles.push({ file: encode(riskPdfBuffer), type: "pdf", fileMetas: [] });
        }

        console.log("FINAL USER FILES =======>>>>", userFiles);
        console.log("RETURNED DATA USER FILES =======>>>>", { ...obj, uploadPath, userFiles: userFiles });

        return { ...obj, uploadPath, userFiles: userFiles }
      })
      customersList = await Promise.all(customersListFiles);
    }

    //set type to submit because we want the user to create an entirely new KYC
    // try {
    // let res =
    //   await axios.post(`${appConfigContext.apiUrl}/generatePDF`, {
    //     customersList: customersList,
    //   });


    let isSuccess = false;
    if (props?.fromServer) {
      const generateCustomerPDF = httpsCallable<any, BaseResult>(functions, "generateCustomerPDF");
      const res = await generateCustomerPDF({ "customersList": customersList, customPath: props?.customPath, customFileName: props?.customFileName });
      isSuccess = !!res?.data;
      // console.log("res =======??", res.data);

      if (isSuccess) {
        if (res?.data?.data?.length == 1) {
          try {
            const storage = getStorage();
            const fileRef = ref(storage, res?.data?.data[0])
            const url = await getDownloadURL(fileRef); // Get the file's download URL
            setGeneratedDocument(url);
          } catch (e) {
            // console.log("ERRRR========>>", e);


          }
        }
      }

    }
    else {

      const customersUpdatedList = showQRCodePDF ? await generateQRCodesForCustomers(customersList) : customersList;
      const contractIsKyc = !props.orderRedemptionRef && !props.transactionContractRef;
      const generateContract = showGenerateContract && !(contractIsKyc && hideKycRows.some(Boolean)) ? await generateContractCall() : null;

      const pdfData = JSON.stringify({
        "customersList": customersUpdatedList,
        ...(generateContract && { "generateContractPdfBase64": generateContract })
      });

      const { data: url, status } = await createPDF(pdfData);

      // console.log("DATA IS HERE ======>>>>", url);

      if (status === "success") {
        isSuccess = true;
        if (url) {
          setGeneratedDocument(url);
          window?.open(url);
        }

      }
    }

    // generateCustomerPDF




    if (isSuccess) {
      setMsg({ type: "success", message: "Success" });
      setConfirming(false)
      // window.location.reload();

    }
    console.log("createPDF success state: ", isSuccess);


    // const pdfBase64 = res?.data.data;
    // const pdfBuffer = decode(pdfBase64)
    // const blob = new Blob([pdfBuffer], { type: 'application/pdf' })
    // const pdfUrl = URL.createObjectURL(blob);
    // window.open(pdfUrl);
    // }
    // catch (e) {
    //   console.log("ERRRRRRR==============>>>>>>", e);
    // }
  }
  const form = useForm({

  });

  return (
    <>
      <Modal
        opened={opened}
        onClose={() => {
          setMsg(null);
          setOpened(false);
          setConfirming(false)
          // props?.setPending(false)
          setDocsDone(0)
          if (props?.onGenerateComplete) {

            props.onGenerateComplete()
          }
          // setDocumentsToInclude([] || documentsToFetch)
        }}
        title="Generate PDF"
      >
        <form
          onSubmit={form.onSubmit(async (values) => {
            console.log(values);

            // setConfirmDialogError(null);
            setMsg(null);
            // props?.setPending(true)

            setConfirming(true);
            console.log("yeaaa we are here");

            try {

              await handleSubmitGeneratePDF()

              // setIsError(true);
            } catch (error: any) {
              // setIsError(true);
              console.log(error);
              // setMsg(error.message);
              // setMsg({type:"error",msg:});
              setMsg({ type: "error", message: error.message });

              setConfirming(false);

              // setConfirmDialogError(error.message);
            }


          })}
        >

          <Space h="xl" />
          {(!props.hidePDFOptions) && <Grid>
            {/* KYC Form is needed only OLD KYC */}
            {!props.completedKYCData && (
              <Grid.Col span={{ md: 12, lg: 6 }}>
                {/* TODO:  only enable this when asked by the parent component.  Orders for instance must have a KYC after order date. */}
                {/* TODO: this needs some major refactoring.  typing out URLs three times for a single checkbox is very, very wrong. */}
                <Checkbox
                  disabled={confirming}
                  label="KYC Form"
                  checked={
                    documentsToInclude?.some((doc: any) => (doc.path === config.pdf_documents?.kyc))

                  }
                  onChange={(e) => e.currentTarget.checked ? setDocumentsToInclude([...documentsToInclude, { name: "kyc", path: config.pdf_documents!.kyc, title: "KYC Document", }]) : setDocumentsToInclude(documentsToInclude.filter((docObj: any) => {
                    return !_.isEqual(docObj, { path: config.pdf_documents!.kyc, name: "kyc", title: "KYC Document", })
                  }))}
                />
              </Grid.Col>)}
            {/* 
            <Grid.Col span={{ md: 12, lg: 6 }}>
              <Checkbox
                disabled={confirming}

                label="KFH Trade Form"
                checked={
                  documentsToInclude?.some((doc: any) => doc.path === 'https://storage.googleapis.com/public-pdfs/KFHtrade-contract-new.pdf')
                }
                onChange={(e) => e.currentTarget.checked ? setDocumentsToInclude([...documentsToInclude, { path: "https://storage.googleapis.com/public-pdfs/KFHtrade-contract-new.pdf", title: "KFH Trade Document", }]) : setDocumentsToInclude(documentsToInclude.filter((docObj: any) => {
                  return !_.isEqual(docObj, { path: "https://storage.googleapis.com/public-pdfs/KFHtrade-contract-new.pdf", title: "KFH Trade Document", })
                }))}
              />
            </Grid.Col> */}
            {/* FATCA form is needed only OLD KYC */}
            {!props.completedKYCData && (
              <Grid.Col span={{ md: 12, lg: 6 }}>
                <Checkbox
                  disabled={confirming}

                  label="Fatca Form"
                  checked={
                    documentsToInclude?.some((doc: any) => doc.path === 'https://storage.googleapis.com/public-pdfs/fatca-cayman.pdf')
                  }
                  onChange={(e) => e.currentTarget.checked ? setDocumentsToInclude([...documentsToInclude, { path: "https://storage.googleapis.com/public-pdfs/fatca-cayman.pdf", title: "FATCA Document", }]) : setDocumentsToInclude(documentsToInclude.filter((docObj: any) => {
                    return !_.isEqual(docObj, { path: "https://storage.googleapis.com/public-pdfs/fatca-cayman.pdf", title: "FATCA Document", })
                  }))}
                />
              </Grid.Col>
            )}

            <Grid.Col span={{ md: 12, lg: 6 }}>
              <Checkbox
                disabled={confirming}

                label="High Risk Form"
                checked={
                  documentsToInclude?.some((doc: any) => doc.path === 'https://storage.googleapis.com/public-pdfs/highrisk_letter.pdf')

                }

                onChange={(e) => e.currentTarget.checked ? setDocumentsToInclude([...documentsToInclude, { path: "https://storage.googleapis.com/public-pdfs/highrisk_letter.pdf", title: "High Risk Document", }]) : setDocumentsToInclude(documentsToInclude.filter((docObj: any) => {
                  return !_.isEqual(docObj, { path: "https://storage.googleapis.com/public-pdfs/highrisk_letter.pdf", title: "High Risk Document", })
                }))}
              />
            </Grid.Col>

            {
              metaTypes && metaTypes?.length > 0 &&

              <>

                {metaTypes?.map((metaType) => {
                  console.log("MetaType", metaType);
                  if (metaType.key === "hasExpiryDate") return null;

                  return (<Grid.Col span={{ md: 12, lg: 6 }}>

                    <Checkbox
                      label={metaType?.name}
                      disabled={confirming}

                      checked={
                        documentsToInclude?.some((doc: any) => doc.metaKey === metaType?.key)
                      }
                      onChange={(e) => e.currentTarget.checked ? setDocumentsToInclude([...documentsToInclude, { metaKey: metaType?.key, title: metaType.name }]) : setDocumentsToInclude(documentsToInclude.filter((docObj: any) => {
                        return !_.isEqual(docObj, { metaKey: metaType?.key, title: metaType.name, })

                      }))}
                    />
                  </Grid.Col>)

                })}
              </>}
            <Grid.Col span={{ md: 12, lg: 6 }}>
              <Checkbox
                label="Risk Status"
                disabled={confirming}
                checked={
                  documentsToInclude?.some((doc: any) => doc.path === "Risk Status")
                }
                onChange={(e) => e.currentTarget.checked ? setDocumentsToInclude([...documentsToInclude, { path: "Risk Status", title: "Risk Status", }]) : setDocumentsToInclude(documentsToInclude.filter((docObj: any) => {
                  return !_.isEqual(docObj, { path: "Risk Status", title: "Risk Status", })
                }))}
              />
            </Grid.Col>

            <>
              <Grid.Col span={{ md: 12, lg: 6 }}>


                <Checkbox
                  label="PACI Civil ID"
                  disabled={confirming}
                  checked={
                    documentsToInclude?.some((doc: any) => doc.path === "Civil ID")
                  }
                  onChange={(e) => e.currentTarget.checked ? setDocumentsToInclude([...documentsToInclude, { path: "Civil ID", title: "Civil ID", }]) : setDocumentsToInclude(documentsToInclude.filter((docObj: any) => {
                    return !_.isEqual(docObj, { path: "Civil ID", title: "Civil ID", })
                  }))}


                />
              </Grid.Col>
            </>

            {/* aml screening If available */}
            {((props.aml_screening && Object.keys(props.aml_screening).length > 0)) &&
              <>
                <Grid.Col span={{ md: 12, lg: 6 }}>
                  <Checkbox
                    label="AML Screening Data"
                    disabled={confirming}
                    checked={
                      documentsToInclude?.some((doc: any) => doc.path === "AML Screening Data")
                    }
                    onChange={(e) => e.currentTarget.checked ? setDocumentsToInclude([...documentsToInclude, { path: "AML Screening Data", title: "AML Screening Data", }]) : setDocumentsToInclude(documentsToInclude.filter((docObj: any) => {
                      return !_.isEqual(docObj, { path: "AML Screening Data", title: "AML Screening Data", })
                    }))}
                  />
                </Grid.Col>
              </>}

          </Grid>}

          <Space h="md" />
          <Checkbox
            label='Show QR code with PACI stamp'
            disabled={confirming || props.manual}
            checked={showQRCodePDF}
            onChange={(e) => e.currentTarget.checked ? setShowQRCodePDF(true) : setShowQRCodePDF(false)}
          />
          <Space h="md" />

          {(props.paymentConfirmations && props.paymentConfirmations.length > 0) &&
            (
              <Checkbox
                label='KFH Payment Confirmation'
                disabled={confirming}
                checked={
                  documentsToInclude?.some((doc: any) => doc.path === "Payment Confirmation")
                }
                onChange={(e) => e.currentTarget.checked ? setDocumentsToInclude([...documentsToInclude, { path: "Payment Confirmation", title: "Payment Confirmation", }]) : setDocumentsToInclude(documentsToInclude.filter((docObj: any) => {
                  return !_.isEqual(docObj, { path: "Payment Confirmation", title: "Payment Confirmation", })
                }))}
              />
            )
          }

          {props.generatingForCollection === "transaction" && (
            <Checkbox
              label="Payment Details"
              disabled={confirming}
              checked={documentsToInclude.some(document => document.path === "Payment Details")}
              onChange={event => setDocumentsToInclude(event.currentTarget.checked
                ? [...documentsToInclude, { path: "Payment Details", title: "Payment Details" }]
                : documentsToInclude.filter(document => document.path !== "Payment Details"))}
            />
          )}


          {(props.completedKYCData || props.orderRedemptionRef || props.transactionContractRef) && (
            <>
              <Checkbox
                label='Generate Contract'
                disabled={confirming}
                checked={showGenerateContract}
                onChange={(e) => {
                  setShowGenerateContract(e.currentTarget.checked);
                  if (!e.currentTarget.checked) {
                    setSelectedContractPdfTags([]);
                  }
                }}
              />
              <Space h="md" />
              {showGenerateContract && props.pdfTags && props.pdfTags.length > 0 && (
                <>
                  <Radio.Group
                    label="Contract Language"
                    value={contractLang}
                    onChange={(val) => setContractLang(val as 'ar' | 'en')}
                    mb="md"
                  >
                    <Group mt="xs">
                      <Radio value="ar" label="Arabic" disabled={confirming} />
                      <Radio value="en" label="English" disabled={confirming} />
                    </Group>
                  </Radio.Group>

                  {props.pdfTags && props.pdfTags.length > 0 && (
                    <Grid>
                      {props.pdfTags
                        .filter((tag: string) => !['agreement', 'thank-you', 'shown_in_final_agreement_checkbox'].includes(tag))
                        .map((tag: string) => {
                          const formattedLabel = tag
                            .split('-')
                            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                            .join(' ');

                          return (
                            <Grid.Col span={{ md: 12, lg: 6 }} key={tag}>
                              <Checkbox
                                label={formattedLabel}
                                disabled={confirming}
                                checked={selectedContractPdfTags.includes(tag)}
                                onChange={(e) => {
                                  if (e.currentTarget.checked) {
                                    setSelectedContractPdfTags([...selectedContractPdfTags, tag]);
                                  } else {
                                    setSelectedContractPdfTags(selectedContractPdfTags.filter((t) => t !== tag));
                                  }
                                }}
                              />
                            </Grid.Col>
                          );
                        })}
                    </Grid>
                  )}
                </>
              )}
            </>
          )}

          <Space h="md" />
          <Group>
            <Button color="grape" type="submit" loading={confirming}>
              {confirming
                ? `Generating ${docsDone}/${rows.length}`
                : `Generate KYC for ${rows.length} customers`}
            </Button>

          </Group>

          <Space h="xl" />

          {msg && (
            <Alert
              icon={<IconAlertCircle size={16} />}
              color={msg.type == "success" ? "green" : "red"}
              title={msg.type == "success" ? <>Success


              </> : "Failure"}
            >
              <Grid justify="start">
                <Grid.Col span={12}>

                  {msg.message}

                  <span>
                    {generatedDocument && <Button color="blue" variant="transparent" mx={10} p={0} component="a" href={generatedDocument} target="_blank">

                      View The PDF
                    </Button>}
                  </span>
                </Grid.Col>
                {/* <Grid.Col span={12} offset={0}>



                </Grid.Col> */}
              </Grid>
            </Alert>
          )}
        </form>
      </Modal>
    </>
  );
}

export default GeneratePDFModal;
